import { render, staticRenderFns } from "./DataReportTableCard.vue?vue&type=template&id=63d6b830&scoped=true"
import script from "./DataReportTableCard.vue?vue&type=script&lang=js"
export * from "./DataReportTableCard.vue?vue&type=script&lang=js"
import style0 from "./DataReportTableCard.vue?vue&type=style&index=0&id=63d6b830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d6b830",
  null
  
)

export default component.exports